/**
 * DateTimeExtraField.jsx — date + time picker for `datetime-local` matrix extra
 * fields (currently only `incident_datetime`). Composes the styled DateInput
 * with a native time input so it matches the rest of the form rather than a bare
 * browser datetime-local control.
 *
 * Shared by the submission wizard AND the case-file Edit Incident Details modal
 * so both edit the same `YYYY-MM-DDTHH:mm` value with an identical control.
 *
 * onChange(fieldKey, nextValue) — two-arg, matching the wizard's
 * handleTypeSpecificChange(key, value). The time input stays disabled until a
 * date is chosen; clearing the date clears the whole value.
 *
 * `id` overrides the date input's id (default `ts-<fieldKey>-date`) so a caller
 * outside the type_specific extras — the Refusal Register's "date and time of the
 * request" — can point its <label htmlFor> and first-error focus jump at it.
 */
import React from 'react';
import DateInput, { todayIso } from './DateInput.jsx';

export default function DateTimeExtraField({ fieldKey, value, onChange, id }) {
  const [datePart, timePart] = (value || '').split('T');
  const time = (timePart || '').slice(0, 5);

  return (
    <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap', alignItems: 'center' }}>
      <DateInput
        id={id || `ts-${fieldKey}-date`}
        name={`${fieldKey}_date`}
        value={datePart || ''}
        max={todayIso()}
        style={{ flex: '1 1 160px' }}
        onChange={e => {
          const d = e.target.value;
          onChange(fieldKey, d ? `${d}T${time || '00:00'}` : '');
        }}
      />
      <input
        type="time"
        className="input"
        aria-label="Time"
        style={{ flex: '0 1 120px' }}
        value={time}
        disabled={!datePart}
        onChange={e => {
          const t = e.target.value;
          if (datePart) onChange(fieldKey, `${datePart}T${t || '00:00'}`);
        }}
      />
    </div>
  );
}
